module.exports = __webpack_public_path__ + "montserrat-regular-webfont.5c3e35fda59991fcfc64.woff";


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/src/assets/fonts/montserrat-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-regular-webfont.woff
// module chunks = 1